// import React from 'react';
import { styled } from '@mui/material/styles';
import { DualUseServicesClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import { dualUseGoods } from 'kosmos/images';
import EsgLegand from './_esgLegand';
import { useTranslation } from 'react-i18next';

const PREFIX = '_dualUseServicesReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
}));

interface IProps {
  name?: string;
  dualUseServicesReport: DualUseServicesClobDto[];
}

export default function DualUseServicesReport(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const { name = t('dual-use-services'), dualUseServicesReport } = props;

  const renderSingleClob = (item: DualUseServicesClobDto, index: number) => {
    const { entitySummaryCode, entitySummaryDetail, affinity } = item;
    const code: string = entitySummaryCode || t('unknown');
    const desc: string = entitySummaryDetail || t('unknown');
    const title = `${code} - ${desc}`;

    return (
      <SdgScoreClob withBorder={true} withBg={true} key={index} title={title} affinity={affinity} />
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: t('business-services-identified-as-used-for-military-purpose'),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'warning',
        title: t(
          'business-services-identified-as-dualuse-and-potentially-used-for-military-purpose',
        ),
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'positive',
        title: t('business-services-identified-as-nondualuse-good'),
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title={t('activity-check-against-dualuse-services-lists')}
        learnMoreTabId="dug"
      />
    );
  };

  const renderContent = () => {
    if (dualUseServicesReport.length === 0) {
      return <Empty title={t('did-not-identify-any-dual-use-services')} />;
    }

    return <Root>{dualUseServicesReport.map(renderSingleClob)}</Root>;
  };

  return (
    <SubSection title={name} isBold icon={<img src={dualUseGoods} />}>
      <>
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}
